export const POS_LOGIN = "POS_LOGIN";
export const POS_LOGOUT = "POS_LOGOUT";
export const POS_SET_ACTIVE_STORE = "POS_SET_ACTIVE_STORE";
export const POS_LOGIN_ERROR = "POS_LOGIN_ERROR";
